import { Trash2 } from 'lucide-react';
import { TRASH_RETENTION_DAYS } from '@family-wishlist/shared';
import { WishCard } from '@/components/WishCard/WishCard';
import { useRestoreWish, useWishes } from '@/features/wishes/wishes.hooks';
import { daysLeftUntil } from '@/lib/format';
import { useI18n } from '@/i18n/i18n';

export function TrashPage() {
  const { dayCount, t } = useI18n();
  const { data, isLoading } = useWishes('deleted');
  const restore = useRestoreWish();

  return (
    <div className="grid gap-6">
      <section className="page-section">
        <h1 className="page-section__title">{t('trash.title')}</h1>
        <p className="page-section__text">
          {t('trash.description', { days: dayCount(TRASH_RETENTION_DAYS) })}
        </p>
      </section>

      {isLoading && <div className="text-muted">{t('common.loading')}</div>}

      {!isLoading && data && data.length === 0 && (
        <div className="empty-state">
          <Trash2 className="empty-state__icon" />
          <h2 className="empty-state__title">{t('trash.emptyTitle')}</h2>
          <p className="empty-state__text">
            {t('trash.emptyText', { days: dayCount(TRASH_RETENTION_DAYS) })}
          </p>
        </div>
      )}

      {data && data.length > 0 && (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((wish) => {
            const left = wish.deletedAt
              ? daysLeftUntil(wish.deletedAt, TRASH_RETENTION_DAYS)
              : TRASH_RETENTION_DAYS;
            return (
              <WishCard
                key={wish.id}
                wish={wish}
                view="owner"
                onRestore={() => restore.mutate(wish.id)}
                footer={
                  <p className="mt-2 text-xs font-medium text-warning">
                    {t('trash.autoRemove', { days: dayCount(left) })}
                  </p>
                }
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
